import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { logger } from '@core/utils/logger';
import { version } from '@env/version';

logger.version(`Dinno front v${version.version} (build ${version.builtAt})`);

bootstrapApplication(App, appConfig).catch((err) =>
  logger.error('App', 'No se pudo iniciar la aplicación', err),
);
